<div class="floating-qa">
  @if (expanded) {
    <div class="floating-qa__backdrop" (click)="collapse()"></div>
  }

  <div
    class="floating-qa__boundary"
    #boundary
    [style.top.px]="topMargin"
    [style.bottom.px]="bottomMargin"></div>

  <div
    class="floating-qa__anchor"
    [class.floating-qa__anchor--left]="side === 'left'"
    cdkDrag
    [cdkDragBoundary]="boundary"
    [cdkDragFreeDragPosition]="dragPosition"
    [cdkDragDisabled]="expanded"
    (cdkDragEnded)="onDragEnded($event)">
    @if (expanded) {
      <div class="floating-qa__row">
        @for (slot of filledSlots; track slot.id) {
          @if (slot.isAction) {
            <button
              type="button"
              class="floating-qa__item"
              [title]="slot.customLabel || (slot.titleKey | translate)"
              longPress
              (longPress)="onItemLongPress()"
              (click)="onItemClick(slot)"
              (contextmenu)="$event.preventDefault()">
              <span class="floating-qa__item-icon">
                <shared-quick-access-icon [page]="slot"></shared-quick-access-icon>
              </span>
              <span class="floating-qa__item-label">
                {{ slot.customLabel || (slot.titleKey | translate) }}
              </span>
            </button>
          } @else {
            <a
              class="floating-qa__item"
              [routerLink]="suppressNavigation ? null : [slot.path]"
              [title]="slot.customLabel || (slot.titleKey | translate)"
              longPress
              (longPress)="onItemLongPress()"
              (click)="onItemClick(slot)"
              (contextmenu)="$event.preventDefault()">
              <span class="floating-qa__item-icon">
                <shared-quick-access-icon [page]="slot"></shared-quick-access-icon>
              </span>
              <span class="floating-qa__item-label">
                {{ slot.customLabel || (slot.titleKey | translate) }}
              </span>
            </a>
          }
        }
      </div>
    }

    @if (showHint && !expanded) {
      <div class="floating-qa__hint" (click)="dismissHint.emit()">
        <div class="floating-qa__hint-bubble">
          {{ 'mobileNav.customizeOnboardingHint' | translate }}
        </div>
      </div>
    }

    <button type="button" class="floating-qa__toggle" (click)="toggle()">
      <i class="fa fa-bars"></i>
    </button>
  </div>
</div>
